import React, { useEffect, useMemo, useRef, useState } from "react"
import { Badge, Button, Container, UncontrolledTooltip } from "reactstrap"

import {
  formatAmount,
  getICDAgreementsStatus,
  getTableSortingHeaderIcon,
  handleDownload,
} from "helpers/common"
// import hide from "../../assets/images/icons/hide.svg"
import downloadIcon from "../../../../assets/images/downloadGrey.svg"
import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import SchedulesModel from "modals/schedulesModel"
import { Link } from "react-router-dom"
import eye from "../../../../assets/images/icons/eye.svg"
import SignAgreementModal from "pages/InvestorPages/signAgreementModal"
import OutsideClickPopover from "modals/OutsideClickPopover"
import { useLazyGetSignDocumentsWpQuery } from "store/api/wealthpartnerapi/referrals/referrals.api"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { Italic } from "ckeditor5"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const IcdMasterAgreementWp = () => {
  document.title = "Agreements - Prachay"

  const [getResults, { isFetching }] = useLazyGetSignDocumentsWpQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const scheduleRef = useRef(null)
  const [scheduleModel, setScheduleModel] = useState(false)
  const [signingRequestOpen, setSigningRequestOpen] = useState(false)

  const getList = async () => {
    try {
      const { data, success } = await getResults(filters).unwrap()
      if (success) {
        const transformedData = data?.rows.filter(
          (item) => item.doc_type === "ICD_AGREEMENT"
        )
        setData(transformedData)
        setCount(data?.count)
      }
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(
    () => [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        id: "created_at",
        accessorFn: (row) =>
          row?.created_at ? new Date(row.created_at).getTime() : null,
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.formatted_created_at,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Name"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={row?.original.investor?.avatar_url}
            email={row?.original.investor?.email}
            name={row?.original.investor?.name}
          />
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Reference No."),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div>{row?.original?.agreement_ref || "Not Applicable"}</div>
        ),
      },
      {
        header: "Amount(₹)",
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <>₹ {formatAmount(row?.original.amount)}</>,
      },
      {
        header: "Remaining Amount(₹)",
        accessorKey: "remaining_amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>₹ {formatAmount(row?.original.remaining_amount)}</>
        ),
      },
      {
        header: "Expiration Date",
        accessorKey: "formatted_expiration_date",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <>{row?.original.formatted_expiration_date}</>,
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Document Type"),
        accessorKey: "doc_type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            <div className="badge counteroffer">
              <span></span> ICD Master Agreement
            </div>
          </div>
        ),
      },

      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Schedules"),
        accessorKey: "icdSchedules",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <Badge color="primary">{row?.original?.icdSchedules?.length}</Badge>
            {row?.original?.icdSchedules?.length > 0 && (
              <div
                onClick={() => {
                  scheduleRef.current = row?.original?.icdSchedules
                  setScheduleModel(true)
                }}
              >
                <a href={"#"}>View</a>
              </div>
            )}
          </div>
        ),
      },
      {
        header: () => <div className="flex items-center gap-2">Status</div>,
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {getICDAgreementsStatus(row?.original?.status)}
          </div>
        ),
      },
      // {
      //   header: "Audit Trail",
      //   id: "audit_trail",
      //   cell: ({ row }) => {
      //     const viewAuditTooltip = `viewAuditTooltip-${row?.original?.id}`
      //     return (
      //       <>
      //         {["SUCCESS"].includes(row?.original?.status) ? (
      //           <div className="d-flex justify-content-center align-items-center flex-row gap-2">
      //             {/* <a href={row.original.doc}>Sign Now</a> */}
      //             <div className="action-view">
      //               <Link
      //                 to={row.original.audit_doc_url}
      //                 target="_blank"
      //                 id={viewAuditTooltip}
      //               >
      //                 <img src={eye} alt="" />
      //                 <UncontrolledTooltip
      //                   placement="top"
      //                   target={viewAuditTooltip}
      //                 >
      //                   View Audit Trail
      //                 </UncontrolledTooltip>
      //               </Link>
      //             </div>
      //           </div>
      //         ) : (
      //           "Not Applicable"
      //         )}
      //       </>
      //     )
      //   },
      // },
      {
        id: "action",
        header: "Actions",
        cell: ({ row }) => {
          const viewTooltip = `viewTooltip-${row?.original?.id}`
          const downloadTooltip = `downloadTooltip-${row?.original?.id}`
          const rejectedTooltip = `rejectedTooltip-${row?.original?.id}`
          return (
            <>
              {["SUCCESS"].includes(row?.original?.status) ? (
                <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                  <div className="action-view">
                    <Link
                      to={row.original.doc_url}
                      target="_blank"
                      id={viewTooltip}
                    >
                      <img src={eye} alt="" />
                      <UncontrolledTooltip placement="top" target={viewTooltip}>
                        View
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                  <div className="action-view">
                    <Link
                      to={"#"}
                      id={downloadTooltip}
                      onClick={() =>
                        handleDownload(
                          row.original.doc_url,
                          row?.original?.agreement_ref || "ICD Master Agreement"
                        )
                      }
                    >
                      <img src={downloadIcon} alt="" />
                      <UncontrolledTooltip
                        placement="top"
                        target={downloadTooltip}
                      >
                        Download
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                </div>
              ) : (
                <>
                  {["REJECTED"].includes(row?.original?.status) ? (
                    <Link to={"#"} id={rejectedTooltip}>
                      <i
                        className="mdi mdi-information-outline"
                        style={{ color: "#7a7a7a", fontSize: "17px" }}
                      />
                      <OutsideClickPopover
                        target={rejectedTooltip}
                        title="Reason for Rejection"
                        body={row?.original?.reject_reason}
                      />
                    </Link>
                  ) : (
                    <>Not Applicable</>
                  )}
                </>
              )}
            </>
          )
        },
      },
    ],
    []
  )

  const FilterComponents = () => (
    <>
      <Button
        className="btn btn-primary"
        onClick={() => setSigningRequestOpen(true)}
      >
        <i className="mdi mdi-plus me-1"></i> Execute Agreement
      </Button>
    </>
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Agreements"} />

          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            FilterComponents={FilterComponents}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isCustomPageSize={false}
            // isGlobalFilter={true}
            isPagination={false}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
          <div>
            <p
              style={{
                color: "#3b3a3aff",
                padding: "10px 15px",
                fontSize: "14px",
                marginTop: "10px",
                bottom: 100,
                fontStyle: "italic",
              }}
            >
              ⚠️ Note: You can initiate a new agreement only after the existing
              tenure has expired or if you wish to increase the investment
              amount Or if the tranche tenure is more than the Balance Tenure of
              the Master Agreement.
            </p>
          </div>
        </Container>
      </div>

      {scheduleModel && scheduleRef?.current && (
        <SchedulesModel
          open={scheduleModel}
          close={() => {
            setScheduleModel(false)
            scheduleRef.current = null
          }}
          data={scheduleRef.current}
          checkPermission={false}
        />
      )}

      <SignAgreementModal
        open={signingRequestOpen}
        setOpen={(v) => {
          getList()
          setSigningRequestOpen(v)
        }}
        assignedInvestors={true}
      />
    </React.Fragment>
  )
}

export default IcdMasterAgreementWp
